import { Observable } from 'rxjs';

import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	LocalStorageEnum,
	LocalStorageService,
} from '@core/services/storage/local-storage.service';

@Injectable()
export class PlayerTokenInterceptor implements HttpInterceptor {
	constructor(private storage: LocalStorageService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler,
	): Observable<HttpEvent<unknown>> {
		const playerToken =
			(this.storage.get(LocalStorageEnum.PlayerToken) as string) || '';
		if (!playerToken) return next.handle(request);

		const headersWithToken = request.headers.append(
			LocalStorageEnum.PlayerToken,
			playerToken,
		);
		const reqWithToken = request.clone({ headers: headersWithToken });

		return next.handle(reqWithToken);
	}
}
